import {
    ViewListingHighlightIconWrapper,
    ViewListingHighlightSubtitle,
    ViewListingHighlightTitle,
    ViewListingHighlightTextWrapper,
    ViewListingNoServiceFeeWrapper,
} from "../viewListingStyling";

export default function ViewListingNoServiceFee() {
    return (
        <ViewListingNoServiceFeeWrapper>
            <ViewListingHighlightIconWrapper>🥂</ViewListingHighlightIconWrapper>
            <ViewListingHighlightTextWrapper>
                <ViewListingHighlightTitle>No service fee</ViewListingHighlightTitle>
                <ViewListingHighlightSubtitle>You don't have to pay a service fee.</ViewListingHighlightSubtitle>
            </ViewListingHighlightTextWrapper>
        </ViewListingNoServiceFeeWrapper>
    );
}
